/**
 * Tutorial guidato della pagina Report → IVA estera e OSS.
 *
 * In alto il periodo (trimestre o anno), poi le schede: panoramica con la soglia OSS, quadro OSS,
 * clienti UE con partita IVA, export e marketplace, Stati USA, controlli prima della dichiarazione.
 * Le schede si cambiano con un click sulla scheda (non salvano niente); `stopForeignTour` riporta
 * sulla Panoramica se il tutorial ne ha aperta un'altra.
 */
const SCOPE = '[data-tour-scope="foreign"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

// stesso ordine di TABS in views/finance/Foreign.vue
const TAB_ORDER = ['overview', 'oss', 'b2b', 'exports', 'us', 'checks'];

const wait = () => new Promise(resolve => setTimeout(resolve, 300));

let cambiata = false;

async function goTab(value) {
	const tabs = document.querySelectorAll(`${at('tabs')} .v-tab`);
	const tab = tabs[TAB_ORDER.indexOf(value)];
	if (tab && !tab.classList.contains('v-tab--active')) {
		cambiata = true;
		tab.click();
		await wait();
	}
}

export function stopForeignTour() {
	if (!cambiata) return;
	cambiata = false;
	const tabs = document.querySelectorAll(`${at('tabs')} .v-tab`);
	if (tabs[0] && !tabs[0].classList.contains('v-tab--active')) tabs[0].click();
}

export function createForeignTourSteps() {
	return [
		{
			body: 'Qui trovi le vendite spedite fuori dall’Italia divise per regime IVA: OSS per i privati UE, cessioni a clienti UE con partita IVA, esportazioni extra-UE e Stati Uniti. È un report: prezzi, checkout e fatture non cambiano.',
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'IVA estera e OSS',
		},
		{
			body: 'L’OSS si dichiara per trimestre: scegli l’anno e il trimestre, o l’anno intero. Le soglie si calcolano comunque sull’anno e sul precedente.',
			key: 'period',
			placement: 'bottom',
			target: at('period'),
			title: 'Il periodo',
		},
		{
			before: () => goTab('overview'),
			body: 'Le vendite a distanza B2C verso altri Paesi UE: sotto i 10.000 € l’IVA è italiana, oltre è quella del Paese del cliente e serve l’adesione all’OSS. Il report avvisa all’80% e al superamento.',
			key: 'threshold',
			placement: 'bottom',
			target: at('threshold'),
			title: 'La soglia OSS',
		},
		{
			before: () => goTab('oss'),
			body: 'Per ogni Paese e aliquota: imponibile e IVA dovuta, scorporata dallo stesso prezzo pagato. La differenza con l’IVA italiana è quanto cambia il margine. Gli ordini in valuta usano il cambio BCE di fine trimestre.',
			key: 'oss',
			placement: 'top',
			target: at('oss'),
			title: 'Il quadro OSS',
		},
		{
			before: () => goTab('oss'),
			body: 'I rimborsi di ordini di un trimestre già chiuso non riducono il trimestre in corso: vanno dichiarati come rettifiche del periodo d’origine.',
			key: 'corrections',
			placement: 'top',
			target: at('corrections'),
			title: 'Le rettifiche',
		},
		{
			before: () => goTab('b2b'),
			body: 'I clienti UE con partita IVA: vendite non imponibili, da riportare negli elenchi Intrastat. Le partite IVA si verificano da sole sul VIES; se una risulta non valida la vendita passa in OSS.',
			key: 'b2b',
			placement: 'top',
			target: at('b2b'),
			title: 'Clienti UE con partita IVA',
		},
		{
			before: () => goTab('exports'),
			body: 'Le spedizioni fuori dall’Unione sono non imponibili, compresi i territori speciali come Canarie e Livigno. Se il canale ha applicato l’IVA italiana lo vedi in arancione.',
			key: 'exports',
			placement: 'top',
			target: at('exports'),
			title: 'Esportazioni',
		},
		{
			before: () => goTab('exports'),
			body: 'Su Amazon ed eBay alcune imposte locali le incassa e versa il marketplace: IVA britannica, VOEC norvegese, sales tax USA. Qui vedi quanto hanno trattenuto.',
			key: 'marketplace',
			placement: 'top',
			target: at('marketplace'),
			title: 'Imposte dei marketplace',
		},
		{
			before: () => goTab('us'),
			body: 'Per ogni Stato le vendite dell’anno confrontate con la soglia di nexus economico. Oltre la soglia, per le vendite dirette, serve la registrazione per la sales tax nello Stato.',
			key: 'us',
			placement: 'top',
			target: at('us'),
			title: 'Stati Uniti',
		},
		{
			before: () => goTab('checks'),
			body: 'Gli ordini da sistemare prima di dichiarare: senza Paese, partite IVA non verificate o non valide, cambi mancanti. Dai tre puntini apri l’ordine e poi torni qui.',
			key: 'checks',
			placement: 'top',
			target: at('checks'),
			title: 'I controlli',
		},
		{
			body: 'Esporta l’Excel con tutte le sezioni e il registro ordine per ordine per il commercialista, o il CSV del quadro OSS. Dalle impostazioni indichi l’adesione all’OSS e correggi aliquote e soglie.',
			key: 'export',
			placement: 'bottom',
			target: at('export'),
			title: 'Export e impostazioni',
		},
	];
}
